import { ForwardedRef } from 'react';

import { CallbackRef } from '../../types';

/**
 * Assigns value to a ref
 * @param ref - callback ref or object
 * @param value - value to assign to a ref
 */
export const assignRef = <T>(
  ref: ForwardedRef<T> | undefined,
  value: T,
): void => {
  if (!ref) return;
  if (typeof ref === 'function') {
    ref(value);

    return;
  }
  // eslint-disable-next-line no-param-reassign
  ref.current = value;
};

/**
 * A function that merges React refs into one callback ref
 * Supports both functions and ref objects created using createRef() and useRef().
 *
 * @example
 * <div ref={mergeRefs(ref1, ref2, ref3)} />
 */
export const mergeRefs =
  <T>(...refs: (ForwardedRef<T | null> | null | undefined)[]): CallbackRef<T> =>
  node => {
    refs.forEach(ref => assignRef<T | null>(ref, node));
  };
